(function() {

  function openCartDrawer() {
    var drawer = document.getElementById('sidebar-cart');
    var overlay = document.querySelector('.PageOverlay');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
    }
    if (overlay) {
      overlay.classList.add('is-visible');
      overlay.style.display = 'block';
      overlay.style.opacity = '1';
      overlay.style.zIndex = '99';
    }
    document.body.classList.add('is-overlaid');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function buildCartHTML(cart) {
    if (cart.item_count === 0) {
      return '<div class="EmptyState Drawer__Container" style="padding:40px 20px;text-align:center"><p>Your cart is empty</p></div>';
    }

    var itemsHTML = '';
    cart.items.forEach(function(item) {
      itemsHTML += `
        <div class="Cart__Item Drawer__Container" style="display:flex;gap:16px;padding:16px 0;border-bottom:1px solid #eee;">
          <div class="Cart__ItemImageWrapper" style="flex-shrink:0;width:80px;height:100px;">
            <img src="${item.image}" alt="${item.title}" style="width:100%;height:100%;object-fit:cover;">
          </div>
          <div class="Cart__ItemInfo" style="flex:1;">
            <div style="display:flex;justify-content:space-between;align-items:flex-start;">
              <div>
                <p class="Cart__ItemTitle" style="font-weight:600;margin:0 0 2px;font-size:13px;text-transform:uppercase;letter-spacing:0.05em;">${item.product_title}</p>
                <p style="color:#888;font-size:12px;margin:0 0 2px;">${formatMoney(item.original_price)}</p>
                <p class="Cart__ItemVariant" style="color:#888;font-size:12px;margin:0 0 8px;">${item.variant_title !== 'Default Title' ? 'SIZE ' + item.variant_title : ''}</p>
              </div>
              <button onclick="window.removeCartItem('${item.key}')" style="background:none;border:none;cursor:pointer;font-size:11px;font-weight:600;letter-spacing:0.08em;text-decoration:underline;color:#222;padding:0;margin-left:8px;">REMOVE</button>
            </div>
            <div style="display:flex;justify-content:space-between;align-items:center;">
              <div style="display:flex;align-items:center;gap:8px;">
                <button onclick="window.updateCartItem('${item.key}', ${item.quantity - 1})" style="border:1px solid #ccc;background:none;width:24px;height:24px;cursor:pointer;font-size:14px;">-</button>
                <span>${item.quantity}</span>
                <button onclick="window.updateCartItem('${item.key}', ${item.quantity + 1})" style="border:1px solid #ccc;background:none;width:24px;height:24px;cursor:pointer;font-size:14px;">+</button>
              </div>
              <span style="font-weight:600;">${formatMoney(item.final_line_price)}</span>
            </div>
          </div>
        </div>
      `;
    });

    return `
      <div style="padding:0 20px;">
        ${itemsHTML}
        <div style="padding:20px 0;position:sticky;bottom:0;background: #fff;">
          <div style="display:flex;justify-content:space-between;font-weight:600;font-size:16px;margin-bottom:16px;">
            <span>Total</span>
            <span>${formatMoney(cart.total_price)}</span>
          </div>
          <a href="/checkout" style="display:block;background:#000;color:#fff;text-align:center;padding:14px;text-decoration:none;font-weight:600;letter-spacing:0.05em;">CHECKOUT</a>
          <a href="/cart" style="display:block;text-align:center;padding:10px;text-decoration:underline;font-size:13px;margin-top:8px;">View Cart</a>
        </div>
      </div>
    `;
  }

  function updateCartCount(count) {
    var bubbles = document.querySelectorAll(
      '.Header__CartCount, .cart-count, [data-cart-count], .CartCount, .cart-item-count'
    );
    bubbles.forEach(function(b) { b.textContent = count; });

    // Update Prestige cart header text "Cart (X)"
    var cartLink = document.querySelector('[data-drawer-id="sidebar-cart"]');
    if (cartLink) {
      cartLink.textContent = count > 0 ? 'Cart (' + count + ')' : 'Cart';
    }
  }

  function refreshAndOpenCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);

        // Inject fresh cart HTML into drawer main area
        var drawerMain = document.querySelector('#sidebar-cart .Drawer__Main');
        if (drawerMain) {
          drawerMain.innerHTML = buildCartHTML(cart);
        }

        // Update footer total if exists
        var drawerFooter = document.querySelector('#sidebar-cart .Drawer__Footer');
        if (drawerFooter) {
          drawerFooter.style.display = 'none'; // hide old footer, we built it into main
        }

        openCartDrawer();
      });
  }

  // Global function for quantity updates
  window.updateCartItem = function(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      var drawerMain = document.querySelector('#sidebar-cart .Drawer__Main');
      if (drawerMain) {
        drawerMain.innerHTML = buildCartHTML(cart);
      }
    });
  };

  // ADD THIS RIGHT HERE 👇
  window.removeCartItem = function(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      var drawerMain = document.querySelector('#sidebar-cart .Drawer__Main');
      if (drawerMain) {
        drawerMain.innerHTML = buildCartHTML(cart);
      }
    });
  };
  function initQuickSizes() {
    document.querySelectorAll('[data-quick-sizes]').forEach(function(el) {
      if (el.dataset.qsInit) return;
      el.dataset.qsInit = '1';
      el.querySelectorAll('.qs-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = btn.dataset.variantId;
          if (!variantId || btn.classList.contains('qs-oos') || btn.disabled) return;
          var origLabel = btn.dataset.label;
          btn.classList.add('qs-loading');
          btn.textContent = '...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
          })
          .then(function(r) {
            if (!r.ok) throw new Error('Cart error');
            return r.json();
          })
          .then(function() {
            btn.textContent = '✓';
            refreshAndOpenCart();
            setTimeout(function() {
              btn.classList.remove('qs-loading');
              btn.textContent = origLabel;
            }, 1500);
          })
          .catch(function(err) {
            console.error('Quick add error:', err);
            btn.classList.remove('qs-loading');
            btn.textContent = origLabel;
          });
        });
      });
    });
  }

  // Close drawer when overlay is clicked
  document.addEventListener('DOMContentLoaded', function() {
    var overlay = document.querySelector('.PageOverlay');
    if (overlay) {
      overlay.addEventListener('click', function() {
        var drawer = document.getElementById('sidebar-cart');
        if (drawer) {
          drawer.setAttribute('aria-hidden', 'true');
          drawer.classList.remove('is-open');
        }
        overlay.classList.remove('is-visible');
        overlay.style.opacity = '';
        overlay.style.display = '';
        document.body.classList.remove('is-overlaid');
      });
    }
    initQuickSizes();
  });

  document.addEventListener('shopify:section:load', initQuickSizes);
  var obs = new MutationObserver(function() { initQuickSizes(); });
  obs.observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('.ProductItem__ImageWrapper--withAlternateImage').forEach(function(card) {
  card.addEventListener('touchstart', function () {
    this.classList.add('is-touched');
  }, { passive: true });
  card.addEventListener('touchend', function () {
    this.classList.remove('is-touched');
  }, { passive: true });
});




})();